export const AXIS_SCHEDULING_PATH_PREFIX = '/appointment_scheduling';

